import { useContext, useEffect, useState } from 'react'

import Parser from 'html-react-parser'

import { AuthContext } from '../../contexts/auth'
import { IServiceTermsResponse } from '../../sdk/settings/settings.types'
import { sdk } from '../../services/sdk'
import { LoadingText } from '../LoadingText'

import styles from './styles.module.scss'

interface TermAndConditionsProps {
  companyId?: string
  onLoadTerms?: (data: IServiceTermsResponse) => void
}

export const TermsAndConditions = ({
  companyId,
  onLoadTerms,
}: TermAndConditionsProps) => {
  const [data, setData] = useState('')
  const [loading, setLoading] = useState(false)
  const { loginBody } = useContext(AuthContext)

  const getTerms = async () => {
    try {
      setLoading(true)
      let response
      if (companyId && loginBody) {
        response = await sdk.settings.getServiceTermsByCompany(
          companyId,
          loginBody,
        )
      } else if (loginBody) {
        response = await sdk.settings.getServiceTerms(loginBody)
      }

      if (response) {
        if (onLoadTerms) {
          onLoadTerms(response)
        }
        setData(response.text)
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getTerms()
  }, [])
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        {loading ? <LoadingText /> : Parser(data)}
      </div>
    </div>
  )
}
